import React from 'react';

function TimestampToDate({
  timestamp,
  hideTime,
  timeOnly,
}: {
  timestamp: Date | number;
  hideTime?: boolean;
  timeOnly?: boolean;
}): JSX.Element {
  const date = new Date(timestamp);

  const formattedDate = date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });

  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  if (timeOnly) {
    return <>{formattedTime}</>;
  }

  return (
    <>
      {formattedDate} {hideTime ? null : `at ${formattedTime}`}
    </>
  );
}

export default TimestampToDate;
